var React = require('react');

function Feature2 (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0)","key":0},[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M65.8843 27.4023L30.503 66.5925L5 44.9997L17.9235 29.7359L28.6406 38.8098L51.0392 14L65.8843 27.4023Z","fill":"black","stroke":"black","strokeWidth":"5","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M65.8843 17.4023L30.503 56.5925L5 34.9997L17.9235 19.7359L28.6406 28.8098L51.0392 4L65.8843 17.4023Z","fill":"white","stroke":"black","strokeWidth":"5","key":1})]),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0"},React.createElement("rect",{"width":"70","height":"70","fill":"white"})))]);
}

Feature2.defaultProps = {"width":"70","height":"70","viewBox":"0 0 70 70","fill":"none"};

module.exports = Feature2;

Feature2.default = Feature2;
